var map = {
	"./person-1.webp": 9065,
	"./person-10.webp": 1426,
	"./person-11.webp": 4962,
	"./person-2.webp": 2439,
	"./person-3.webp": 5981,
	"./person-4.webp": 5783,
	"./person-5.webp": 2122,
	"./person-6.webp": 2756,
	"./person-7.webp": 343,
	"./person-8.webp": 8066,
	"./person-9.webp": 5407
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8053;